import { competenceTypesState, competenceTypeState, editCompetenceTypeState, newCompetenceTypeState } from "./competencetypes.states";

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

import { CompetenceTypes } from "./competencetypes.component";
import { EditCompetenceType } from "./competencetype.edit.component";
import { CompetenceType } from "./competencetype.component";

const STATES = [competenceTypesState, competenceTypeState, editCompetenceTypeState, newCompetenceTypeState];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: STATES })
    ],
    exports: [],
    declarations: [CompetenceTypes, EditCompetenceType, CompetenceType],
    providers: [],
    entryComponents: [ConfirmDialog]
})
export class CompetenceTypesModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencetypes/competencetypes.module.ts